import { Group } from '@mantine/core'
import Select from '../inputs/Select';
import React, { useImperativeHandle } from 'react'
import { saveDeal } from 'app/state/ducks/deals/thunks'
import { useDispatch } from 'react-redux'
import { useForm } from '@mantine/form'
import {
  DealParams,
  DraftDealParams
} from 'app/models/deal-params'
import { saveDealAmendment } from 'app/state/ducks/deal-amendments/thunks'
import { ErrorNotification, SuccessNotification } from '../notifications/notification'



type Props = {
  deal: any
  setDeal: React.Dispatch<React.SetStateAction<any>>
  setAmendment: React.Dispatch<React.SetStateAction<any>>
  amendment?: string | null | undefined
  dealAmendment?: DraftDealParams | DealParams
  setDisabledSteps?: React.Dispatch<React.SetStateAction<number[]>>
}

type FormValues = {
  allowNonProRataAssignments: boolean;
};

export interface ChildDealManageAssignabilityRef {
  handleClick: () => void
}

const DealAssignabilityComponent: React.ForwardRefRenderFunction<
  ChildDealManageAssignabilityRef,
  Props
> = ({ deal, setDeal, setAmendment, amendment, dealAmendment }, ref) => {
  const dispatch = useDispatch()

  deal = dealAmendment ? dealAmendment : deal

  const form = useForm<FormValues>({
    initialValues: {
      allowNonProRataAssignments: deal?.allowNonProRataAssignments ?? false,
    },
    validate: {
      allowNonProRataAssignments: (value) =>
        typeof value === 'boolean' ? null : 'Please select Yes or No',
    },
  })

  const handleClick = async () => {
    let dealSubmission
    let response: any
    const submit = !form.validate().hasErrors

    if (!submit) {
      return;
    }

    const dealValues = {
      ...deal,
      allowNonProRataAssignments: form.values.allowNonProRataAssignments,
    }

    try {
      if (amendment) {
        const dealAmendmentId = dealAmendment?.id ?? null
        dealSubmission = saveDealAmendment(dealValues, dealAmendmentId)
      } else {
        dealSubmission = saveDeal(dealValues, deal.id)
      }

      response = await dispatch(dealSubmission)

      if (response.success) {
        if (amendment) {
          setAmendment(dealValues)
        } else {
          setDeal(dealValues)
        }
        SuccessNotification({
          title: 'Deal Updated Successfully',
          message: 'Assignability options have been saved.',
        })
      } else {
        ErrorNotification({
          title: 'Failed to Update Deal',
          message: response.payload ?? 'Check assignability inputs and try again',
        })
      }
    } catch (error) {
      ErrorNotification({
        title: 'Unexpected Error',
        message: 'Something went wrong while saving assignability: ' + error,
      })
    }
  }

  // Expose the handleClick method to the parent component
  useImperativeHandle(ref, () => ({
    handleClick,
  }))

  return (
    <div>
      <Group
        grow
      >
        <Group w='100%' grow style={{ paddingBottom: '10px', height: 'auto' }}>
          <Select
            data-testid="allow-non-prorata-select"
            label="Non Pro Rata Assignments"
            {...form.getInputProps('allowNonProRataAssignments')}
            data={[
              { label: 'Yes', value: 'true' },
              { label: 'No', value: 'false' }
            ]}
            value={form.values.allowNonProRataAssignments.toString()}
            onChange={(val) =>
              form.setFieldValue('allowNonProRataAssignments', val === 'true')
            }
          />
        </Group>
      </Group>
    </div>
  )
}
export default React.forwardRef(DealAssignabilityComponent)